import React,{useState,useEffect} from "react";
import useStyles from './style'
import { TextField,Button,Typography,Paper } from "@material-ui/core";
import FileBase from 'react-file-base64'
import {useDispatch} from 'react-redux'
import { createPost,updatePost } from "../../actions/posts";
import { useSelector } from "react-redux";
import { Link } from "react-router-dom";

import CloseIcon from '@material-ui/icons/Close';



const Form=({currentId,setCurrentId,setView,setCreateview})=>{
    const classes=useStyles();
    const post=useSelector((state)=>currentId ? state.posts.find((p)=>p._id===currentId):null)
    const [postData,setPostdata]=useState({title:'',message:'',tags:'',selectedFile:''})
    const dispatch =useDispatch();
    const user=JSON.parse(localStorage.getItem('profile'))

    useEffect(()=>{
        if(post) setPostdata(post)
    },[post])

    const handleSubmit=(e)=>{
            e.preventDefault()
            if(currentId){
                dispatch(updatePost(currentId,{...postData,name:user?.result?.name}))
            }else{
            dispatch(createPost({...postData,name:user?.result?.name}))}
            clear()
    }

    const clear=()=>{
        setCurrentId(null);
        setPostdata({title:'',message:'',tags:'',selectedFile:''})
    }

    if(!user?.result?.name){
        return(
            <Paper className={classes.paper}>
                <Typography variant="h6" align="center">
                    Please Sign In to create your own posts and like others Post
                </Typography>
            </Paper>
        )
    }

    return(
        <Paper className={classes.paper}>
        <Button onClick={()=>{setView(false)
        setCreateview(false)}} component={Link} to="/"><CloseIcon/></Button>
            <form autoComplete="off" noValidate className={`${classes.root} ${classes.form} `} onSubmit={handleSubmit}>
            <Typography variant="h6">{currentId?'Editing':'Creating'} a Post</Typography>
            <TextField name="title" variant="outlined" label="Title" fullWidth value={postData.title} onChange={(e)=>setPostdata({...postData,title:e.target.value})}/>
            <TextField name="message" variant="outlined" label="Message" fullWidth value={postData.message} onChange={(e)=>setPostdata({...postData,message:e.target.value})}/>
            <TextField name="tags" variant="outlined" label="Tags" fullWidth value={postData.tags} onChange={(e)=>setPostdata({...postData,tags:e.target.value.split(',')})}/>
            <div className="fileInput">
                <FileBase
                type="file"
                multiple={false}
                onDone={({base64})=>setPostdata({...postData,selectedFile:base64})} />
            </div>
            <Button className={classes.buttonSubmit} variant="contained" color="primary" size="large" type="submit" fullWidth>Submit</Button>
            </form>
            </Paper>
        
    )
}

export default Form;